import { Text } from '@/componentsV1/BaseComponents'

export const TaxfylePortalError = ({ error }: { error: string | null }) => {
  if (!error) {
    return null
  }
  return (
    <div role="alert" className="mt-2">
      <Text as="bodyXs" color="red">
        {error}
      </Text>
    </div>
  )
}
